import { retryUntilReady } from "./pixelRetry";

declare global {
	interface Window {
		oaiq?: any;
	}
}

/**
 * Track a ChatGPT (OpenAI) Pixel event (standard or custom)
 */
export const trackChatGptEvent = (eventName: string, params?: Record<string, any>): void => {
	const pixelId = process.env.REACT_APP_CHATGPT_PIXEL_ID;

	if (!pixelId) {
		console.log(`ChatGPT Pixel event skipped: ${eventName} (missing ID)`);
		return;
	}

	const fire = () => {
		window.oaiq("track", eventName, params);
		console.log(`📊 ChatGPT Pixel event: ${eventName}`, params);
	};

	if (typeof window.oaiq === "function") {
		fire();
	} else {
		retryUntilReady(
			() => typeof window.oaiq === "function",
			fire,
			() => console.warn(`⚠️ ChatGPT Pixel not initialized, dropped event: ${eventName}`)
		);
	}
};
